<template>
  <div>
    <div class="realtimeinfo" v-if='isdelite'>
      <div style="margin:10px 0 0 20px;display:flex;align-items:center">

        <div style="margin-right:20px">{{ $t('manipulation.devName') }}：<span
            style="border:1px solid #aaa;border-radius:4px;padding:5px 20px">{{ proname }}</span></div>
        <prowerSetting @selectStation="selectStation" />
        <div style="margin-left: 5%;">
          <el-cascader :options="options" v-model="towervalue"
            :props="{ checkStrictly: true, children: 'stairsList', value: 'numberName', label: 'numberName' }"
            clearable></el-cascader>
          <el-button type="primary" style="margin-left:20px" @click="searchtower" plain>{{ $t('realtimeinfo.search')
            }}</el-button>
        </div>
        <div style="flex:1;text-align:end">
          <el-radio-group v-model="radio1" size="medium">
            <el-radio-button icon="el-icon-menu" :label="$t('realtimeinfo.standard')"></el-radio-button>
            <el-radio-button icon="el-icon-s-grid" label="mini"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="con" :class="radio1 === 'mini' ? 'con1' : ''">
        <div class="item_list"
          :class="`${radio1 === 'mini' ? 'item_list1' : 'item_list2'} ${item.workStatus == 1 && item.onlineFlag == 1 ? 'item_con' : ''}`"
          v-for="(item, index) in   devicelist  " :Key='index'>

          <div class="list_top">
            <p></p>
            <p style="flex:1">{{ $t('realtimeinfo.roomNum') }}:{{ item.towerNumber }} &nbsp;
              {{ $t('realtimeinfo.eleNum') }}:{{ item.stairsNumber }}</p>
            <p><img src="~@/assets/img/wifi.png" /></p>
          </div>
          <div class="list_bot">
            <div style="flex:1" @click="hanldinfo(item)"><img src="~@/assets/img/dt.png" style="width:81%" /></div>
            <div style="flex:1">
              <div style="height:40%">

                <el-button type="primary" plain v-if="String(item.onlineFlag) === '1'">{{ $t('realtimeinfo.onLine')
                  }}</el-button>
                <el-button type="warning" plain v-if="String(item.onlineFlag) === '0'">{{ $t('realtimeinfo.offLine')
                  }}</el-button>
                <el-button type="success" plain v-if="String(item.workStatus) === '1'">{{ $t('realtimeinfo.powerOn')
                  }}</el-button>
                <el-button type="danger" plain v-if="String(item.workStatus) === '0'">{{ $t('realtimeinfo.turnOff')
                  }}</el-button>
              </div>
              <div class="colflex" style="height:60%">
                <div class="but1">
                  <div>{{ $t('realtimeinfo.eleTem') }}</div>
                  <div>{{ item.devTemperatures }}°C</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if='!isdelite'>
      <Realdetile ref='realdetile' @goblack='goblack' />
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import prowerSetting from '@/components/power/prowerSetting';
import { getDeviceListById, projectinfo, getTowerAndStairsNumberByProjectId } from "@/api/devicemon";
import Realdetile from './realdetile'
import { formatRunStatus, formatBinaryStatus } from '@/util/monitorMetrics'
export default {
  name: 'realtimeinfo',
  components: {
    prowerSetting, Realdetile
  },
  data() {
    return {
      devicelist: [

      ],
      towervalue: '',
      options: [],
      isdelite: true,
      wayinfo: '',
      proname: '',
      radio1: this.$t('realtimeinfo.standard'),
      deviceid: ''
    }
  },
  watch: {

  },
  created() {
    this.deviceid = this.stationObj.proid
    console.log(this.stationObj)

    this.getdevice()
    this.getprojectinfo()
    this.getTowerAndStairsNumberByProjectId()
  },
  mounted() {
    const timer = setInterval(() => { this.getdevice() }, 30000);
    this.$once('hook:beforeDestroy', () => clearInterval(timer))
  },
  computed: {
    ...mapGetters(["stationObj"])
  },
  methods: {
    searchtower() {
      console.log(this.towervalue)
      this.getdevice()
    },
    getprojectinfo() {
      projectinfo({ id: this.stationObj.proid }).then(res => {
        if (res.data.code == 200) {
          this.wayinfo = res.data.data
          this.proname = res.data.data.projectName
        }
      })
    },
    getTowerAndStairsNumberByProjectId() {
      getTowerAndStairsNumberByProjectId({ projectId: this.deviceid }).then(res => {

        if (res.data.code == 200) {
          this.options = res.data.data
        }
      })
    },
    getdevice() {
      let obj = {
        id: this.deviceid,
        towerNumber: this.towervalue && this.towervalue.length > 1 ? "" : this.towervalue[0],
        stairsNumber: this.towervalue && this.towervalue.length > 1 ? this.towervalue[1] : '',
        size: 500
      }
      getDeviceListById(obj).then(res => {
        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
            item.workStatus1 = formatBinaryStatus(item.workStatus, {
              zero: this.$t('realtimeinfo.turnOff'),
              one: this.$t('realtimeinfo.powerOn'),
              unreported: this.$t('manipulation.unreported')
            })
            item.runStatus1 = formatRunStatus(item.runStatus, {
              manual: this.$t('realtimeinfo.manual'),
              timing: this.$t('realtimeinfo.timing'),
              unreported: this.$t('manipulation.unreported')
            })
            item.onlineFlag1 = formatBinaryStatus(item.onlineFlag, {
              zero: this.$t('realtimeinfo.offLine'),
              one: this.$t('realtimeinfo.onLine'),
              unreported: this.$t('manipulation.unreported')
            })
          })
          this.devicelist = res.data.data.records
        }
      })
    },
    hanldinfo(val) {
      this.isdelite = false
      setTimeout(() => {
        this.$refs.realdetile.getinfo(val, this.wayinfo, this.devicelist)
      }, 0);
    },
    goblack() {
      this.isdelite = true
    },
    selectStation(data) {
      this.wayinfo = data
      this.proname = data.projectName
      this.deviceid = data.id
      this.getdevice()
      this.getTowerAndStairsNumberByProjectId()
    },
  }
}
</script>
<style lang='scss'>
.realtimeinfo {

  // .con {
  //   display: flex;
  //   flex-wrap: wrap;
  //   margin-top: 20px;
  // }
  .con {
    padding: 0 10px;
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
  }

  .con1 {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
  }

  .item_list2 {
    width: 100%;

    height: 230px;

    .but1 {
      width: 90px;
      height: 90px;

      font-size: 13px;

    }
  }

  .item_list1 {
    width: 100%;

    height: 150px;

    .list_top p:nth-of-type(2) {
      font-size: 12px;
    }

    .list_top {
      img {
        width: 76%;
      }
    }

    .list_bot {
      .el-button {
        padding: 0 7px !important;
        font-size: 12px;
        height: 22px;
        line-height: 20px !important;
      }

      .but1 {
        width: 60px;
        height: 60px;

        font-size: 12px;

      }

      img {
        width: 70% !important;
      }
    }
  }



  .item_list {
    background: #F4F8FC;
    border: 1px solid #A5DEDD;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .list_top {
      padding: 0 10px;
      flex: 1;
      display: flex;
      align-items: center;

      p {
        margin: 0
      }
    }

    .list_top p:nth-of-type(1) {
      width: 3px;
      height: 13px;
      background: #5CC1CF;
      border-radius: 2px;
      margin-right: 5px;
    }

    .list_bot {
      flex: 4;
      display: flex;

    }

    .list_bot div:nth-of-type(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    .colflex {
      justify-content: center;
      display: flex;
    }

    .list_bot div:nth-of-type(2) {
      .but1 {

        background: #D6EFF2;
        color: #01AAA7;
        border-radius: 50%;
        display: flex;

        flex-direction: column;
      }
    }
  }

  .item_con {
    background: #A5DEDD;
  }
}
</style>
